import { render, staticRenderFns } from "./SnackMessage.vue?vue&type=template&id=bef4856e"
import script from "./SnackMessage.vue?vue&type=script&lang=js"
export * from "./SnackMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports